var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content", style: _vm.mainContentViewHeight },
    [
      _c(
        "div",
        { staticClass: "edit-form" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tableChange },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "查询语句配置", name: "basicInfo" } },
                [
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isRouterAlive,
                          expression: "isRouterAlive",
                        },
                      ],
                      ref: "dataForm",
                      attrs: {
                        model: _vm.dataForm,
                        rules: _vm.dataRule,
                        "label-width": "110px",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.dataFormSubmit()
                        },
                      },
                    },
                    [
                      _c("el-form-item", { attrs: { label: "数据源：" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.getDatasourceTitle()))]),
                      ]),
                      _c("el-form-item", { attrs: { label: "业务信息：" } }, [
                        _c("span", [_vm._v(_vm._s(this.$route.params.title))]),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SQL语句：", prop: "sqlClause" } },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.dataForm.sqlClause,
                                expression: "dataForm.sqlClause",
                              },
                            ],
                            ref: "sqlEditor",
                            staticClass: "codesql",
                            attrs: { rows: "20", placeholder: "SQL语句" },
                            domProps: { value: _vm.dataForm.sqlClause },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.dataForm,
                                  "sqlClause",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bolder",
                              },
                            },
                            [
                              _vm._v(
                                "注意：查询过滤条件需要在sql中用<filter/>占位"
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { float: "right" },
                              attrs: { type: "primary", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.dataFormSubmit()
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "查询参数配置", name: "searchArg" } },
                [
                  _vm.isRouterAlive
                    ? _c("config-search-arg", {
                        attrs: { formId: _vm.formId },
                        on: {
                          "update:formId": function ($event) {
                            _vm.formId = $event
                          },
                          "update:form-id": function ($event) {
                            _vm.formId = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "字段映射", name: "datasetField" } },
                [
                  _vm.isRouterAlive
                    ? _c("config-dataset-field", {
                        attrs: { formId: _vm.formId },
                        on: {
                          "update:formId": function ($event) {
                            _vm.formId = $event
                          },
                          "update:form-id": function ($event) {
                            _vm.formId = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "明细页面配置", name: "detailPage" } },
                [
                  _vm.isRouterAlive
                    ? _c("detail-list", {
                        attrs: { formId: _vm.formId },
                        on: {
                          "update:formId": function ($event) {
                            _vm.formId = $event
                          },
                          "update:form-id": function ($event) {
                            _vm.formId = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }